export const EXPAND_CONTAINER_PADDING = 8;
export interface StyleProps {
	'data-node-type'?: 'expand' | 'nestedExpand';
	'data-title'?: string;
	expanded?: boolean;
	focused?: boolean;
}
